import { createSelector } from 'reselect';
import get from 'lodash/get';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';

import BundleProductInfoSelector from '../Bundle/BundleProductInfoSelector';

const getProductDetails = (state) => state.productDetails || {};

const getBundleProductInfo = createSelector(
    [BundleProductInfoSelector],
    (productInfo) => productInfo || {}
);

export const getProductMattressSpec = createSelector(
    [getProductDetails],
    (productDetails) =>
        productDetails.lots &&
        productDetails.lots[0] &&
        productDetails.lots[0].organization &&
        productDetails.lots[0].organization.subdivision === '799'
);

const getKAData = (prodDetails, featureFlags) => {
    // const prodDetails = this.props.productDetails;
    const KnowledgeAssistantArray = prodDetails.knowledgeAssistants
        ? prodDetails.knowledgeAssistants
        : [];
    let KnowledgeAssistantsCount = KnowledgeAssistantArray.length;
    if (
        prodDetails.sizeGuide &&
        Object.keys(prodDetails.sizeGuide) &&
        !get(featureFlags, 'disableDataSizeChart', false)
    ) {
        KnowledgeAssistantsCount += 1;
    }
    return KnowledgeAssistantsCount;
};

const getGeneralInfoData = (productLot, isBundle) => {
    let productLotDefault;
    // const productLot = this.props.productDetails.lots;
    const GeneralInfo = [];

    // to fetch object with default lot ID
    /* istanbul ignore else */
    if (productLot) {
        const toFilter = new Set([true]);
        productLotDefault = productLot.filter((obj) => toFilter.has(obj.isDefault));
    }
    // to push available tag values for default product to Shipping Tags Array
    /* istanbul ignore else */
    if (productLotDefault && productLotDefault[0]) {
        let type = productLotDefault[0].type ? productLotDefault[0].type : [];
        type = typeof type === 'string' ? type.split() : type;
        if (productLotDefault[0].surcharges && type.length) {
            /* istanbul ignore else */
            if (productLotDefault[0].surcharges.recycleFee) {
                GeneralInfo.push('recycleFee');
            }
        }
        if (productLotDefault[0].prop65) {
            GeneralInfo.push('proposition65');
        }
        /* istanbul ignore next */
        if (!isBundle) {
            if (productLotDefault[0].warranties && productLotDefault[0].warranties.length) {
                if (
                    productLotDefault[0].type &&
                    productLotDefault[0].type.includes('FINE_JEWELRY')
                ) {
                    GeneralInfo.push('jeweleryAndWatch');
                }

                if (
                    productLotDefault[0].type &&
                    !productLotDefault[0].type.includes('FINE_JEWELRY')
                ) {
                    GeneralInfo.push('protectionPlan');
                }
            }
        } else if (
            productLotDefault[0].availableWarranties &&
            productLotDefault[0].availableWarranties.length
        ) {
            const { availableWarranties } = productLotDefault[0];
            if (availableWarranties.includes('FINE_JEWELRY')) {
                GeneralInfo.push('jeweleryAndWatch');
            }
            /* istanbul ignore else */
            if (!availableWarranties.includes('FINE_JEWELRY')) {
                GeneralInfo.push('protectionPlan');
            }
        }
    }
    return GeneralInfo;
};

const selectProductInfo = createSelector(
    [getProductDetails, getBundleProductInfo, selectFeatureFlags],
    (productDetails, bundleProductInfo, featureFlags) => {
        let generalInfoData = [];
        let KAData = [];
        const isBundle = productDetails.type && productDetails.type.toLowerCase() === 'bundle';
        const details =
            isBundle && Object.keys(bundleProductInfo).length > 0
                ? bundleProductInfo
                : productDetails;
        if (Object.keys(productDetails).length > 0) {
            generalInfoData = getGeneralInfoData(details.lots, isBundle);
            KAData = getKAData(details, featureFlags);
        }
        return {
            generalInfoData,
            KAData,
        };
    }
);

export default selectProductInfo;
